import React, { ReactNode } from 'react';

import '../../base.css';

type Props = {
  children?: ReactNode;
};

const PageSectionFilledTagline = ({ children }: Props) => {
  return <div styleName="page-section-filled-tagline">{children}</div>;
};

export default PageSectionFilledTagline;
